import { render, staticRenderFns } from "./Yyjsgw.vue?vue&type=template&id=4854dc84&"
import script from "./Yyjsgw.vue?vue&type=script&lang=js&"
export * from "./Yyjsgw.vue?vue&type=script&lang=js&"
import style0 from "./Yyjsgw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports